module.exports = __webpack_public_path__ + "static/new_clients-99873ee1993e4c00745f1d984b5e6c59.svg";